<div class="quick-actions-cell">
  @for (action of quickActionItems; track action.id) {
    <button
      mat-icon-button
      [matTooltip]="action.toolTip"
      class="quick-actions-trigger"
      aria-label="Row actions"
      (click)="onActionItemClick(action)"
      [disabled]="action.disableAction">
      <span class="material-symbols-outlined" [class.active]="!action.disabled" [class.disabled]="action.disableAction">{{action.icon}}</span>
    </button>
  }
